import React from "react";

//import { CodeBlockProps } from "@onclicks/types/CodeBlock";
import { CodeBlock as CodeBlockType } from "@onclicks/payload-types";

import { Code } from "../components/Code";

type Props = CodeBlockType & {
  className?: string;
};

export const CodeBlock: React.FC<Props> = ({ className, code, language }) => {
  return (
    <div className={[className, "not-prose"].filter(Boolean).join(" ")}>
      <Code
        code={code}
        language={language && language !== undefined ? language : "typescript"}
      />
    </div>
  );
};
